import Link from 'next/link'

import * as S from './styles'
import { Button, Text } from '@/components'

type Page404ContainerProps = {
  localePtBr: boolean
}
export const Page404Container: React.FC<Page404ContainerProps> = ({
  localePtBr,
}) => (
  <S.Page404Container>
    <Text size="h1" className="title">
      404
    </Text>
    <Text size="b1" align="center">
      {localePtBr
        ? 'Não localizamos a página que você estava buscando'
        : "We couldn't find the page you were looking for."}
    </Text>
    <Link href="/" passHref>
      <Button>{localePtBr ? 'Retornar para a Home' : 'Return to Home'}</Button>
    </Link>
  </S.Page404Container>
)
